var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.287 19.702a1 1 0 0 0 1.425 0l.001-.002 1.026-1.04 2.414-2.45c1.85-1.876 3.955-4.01 4.983-5.043 2.438-2.454 2.53-6.684.002-9.246A6.42 6.42 0 0 0 11 1.9a6.42 6.42 0 0 0-9.14.021c-2.528 2.562-2.435 6.792.003 9.246 1.028 1.034 3.133 3.167 4.983 5.043.924.938 1.785 1.81 2.414 2.45z",
    clipRule: "evenodd"
  })));
};
export default SvgHeartFilled;